<template>
  <div class="space">
    <div class="image-text-container">
      <div class="row">
        <div class="col-md my-auto">
          <h2 class="short-border-bottom">
            <slot name="title"/>
          </h2>
          <p>
            <slot name="html"/>
          </p>
          <div style="height:15px;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Html"
  }
</script>

<style scoped>

</style>